import axios from "axios";

const STORAGE_KEY = 'kcToken'
const USER_INFO_KEY = 'kcUserInfo'

// Guarda el token de Keycloak
export const saveKeycloakToken = (keycloakInstance) => {
  if (!keycloakInstance || !keycloakInstance.token) return

  try {
    const { exp } = JSON.parse(window.atob(keycloakInstance.token.split(".")[1]));
    const expirationDate = new Date(exp * 1000).toISOString()

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        token: keycloakInstance.token,
        subject: keycloakInstance.subject,
        refreshToken: keycloakInstance.refreshToken,
        expirationDate
      })
    )
  } catch (e) {
    console.log(e)
  }
}

// Lee el token
export const getKeycloakToken = () => {
  const data = localStorage.getItem(STORAGE_KEY)
  return data ? JSON.parse(data) : null
}

/* =======================
   USER INFO
======================= */

// Guarda el userInfo
export const saveKeycloakUserInfo = (userInfo) => {
  if (!userInfo) return

  try {
    localStorage.setItem(
      USER_INFO_KEY,
      JSON.stringify(userInfo)
    )
  } catch (e) {
    console.log(e)
  }
}

// Lee el userInfo
export const getKeycloakUserInfo = () => {
  try {
    const data = localStorage.getItem(USER_INFO_KEY)
    return data ? JSON.parse(data) : null
  } catch (e) {
    return null
  }
}

export const getUserInfo = async (keycloakInstance) => {
  try {
    const headers = {
      headers: { authorization: `Bearer ${keycloakInstance.token}` },
      timeout: 10000
    };
    const { data } =
      await axios.get(
        `${process.env.REACT_APP_KC_URL}realms/megamedia/protocol/openid-connect/userinfo`,
        headers
      )

    return saveKeycloakUserInfo(data)
    
  } catch (error) {
    console.log(`Ocurrió un problema al intentar obtener userinfo de Keycloak`, error);
  }
}